import { lazy } from 'react';

import { Location } from '@cobliteam/common-types';

const AdvancedAnalytics = lazy(() => import('@cobliteam/advanced-analytics'));

const routes = [
  {
    path: Location.ADVANCED_ANALYTICS,
    featureFlag: 'showAdvancedAnalyticsPage',
    component: AdvancedAnalytics,
    accessDeniedDescription: 'ver análises avançadas',
  },
];

export default routes;
